import { useEffect, useState } from 'react';
import Router from './router';
import {
  handleFlutterMessage,
  handleUTaxesMessage,
  checkUrlToken,
  requestTokenFromParent
} from './utils/flutterBridge';
import './utils/flutterBridge'; // 确保全局函数被注册
import { isInApp } from './utils/environment';
import { isAuthenticated } from './utils/auth';

function App() {
  const [isReady, setIsReady] = useState(!isInApp()); // 如果不在App内，直接准备就绪

  useEffect(() => {
    // 1. 首先检查 URL 参数中的 token
    const urlTokenReceived = checkUrlToken();
    if (urlTokenReceived) {
      setIsReady(true);
      return;
    }

    // 2. 添加消息监听器（支持 Flutter 和 u-taxes）
    const messageHandler = (event) => {
      let result = false;

      // 优先处理来自 Flutter 的消息（如果在 App 内）
      if (isInApp()) {
        result = handleFlutterMessage(event);
        if (result) {
          setIsReady(true);
          return; // 早期返回，避免不必要的处理
        }
      }

      // 处理来自 u-taxes 的消息
      result = handleUTaxesMessage(event);
      if (result) {
        setIsReady(true);
      }
    };

    // 监听来自 Flutter 和 u-taxes 的消息
    window.addEventListener('message', messageHandler);

    // 3. 页面加载完成后的初始化
    // 通知 Flutter（如果在 App 内）
    window.notifyFlutterReady?.();

    // 向父窗口请求 token（如果在 iframe 中）
    if (window.parent !== window) {
      requestTokenFromParent();
    }

    // 4. 设置超时机制，避免无限等待
    const timeout = setTimeout(() => {
      // 检查是否已经有 token
      const existingToken = localStorage.getItem('firmServiceToken');
      if (!existingToken) {
        console.warn('Token 获取超时，使用默认状态');
      }
      setIsReady(true);
    }, isInApp() ? 3000 : 5000); // App 内 3秒，iframe 内 5秒

    return () => {
      window.removeEventListener('message', messageHandler);
      clearTimeout(timeout);
    };
  }, []);

  // 在App内且未就绪时，显示加载状态
  if (isInApp() && !isReady) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  return <Router />;
}

export default App; 